<template>
  <div>
    <section class="section section-lg bg">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <figure class="walden">
              <router-link to="/contact">
                <img class="cropped" src="img/stock/roland-vogt-1152687-unsplash.jpg">
              </router-link>
            </figure>
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5 copy">
              <h1 class="display-1 text-primary">Retirement</h1>
              <p>Retirement doesn't have to be a struggle. Planning your future should give you confidence, peace of mind, and clear guidelines for daily decisions.</p>
              <p> At Forward Financial, we obsess over your future, so you don't have to. We provide long-term, wide-ranging solutions to help you cover your blindspots. We help you plan for the best outcomes you can imagine, and we help you make them happen.</p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="success" circle class="mr-3 text-primary" icon="fa fa-bank"></badge>
                    <h6 class="mb-0">Financial Planning</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="success" circle class="mr-3 text-primary" icon="fa fa-briefcase"></badge>
                    <h6 class="mb-0">Financial Consultancy</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="success" circle class="mr-3 text-primary" icon="fa fa-money"></badge>
                    <h6 class="mb-0">Cash Investment</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <free-consultation/>
  </div>
</template>

<script>
import BaseButton from "@/components/BaseButton";
import FreeConsultation from "./FreeConsultation.vue";
export default {
  name: "Services",
  components: {
    BaseButton,
    FreeConsultation
  }
};
</script>
